import Phaser from 'phaser'
import { createCharacterAnims } from '../anims/CharacterAnims'
import { createChestAnims } from '../anims/TreasureAnims'
import { Farmer, PlayerMovement } from '../characters/Playable';
import { Minter } from '../characters/NonPlayable';
import { sceneEvents } from '../events/EventsCenter'

import '../characters/Playable'
import Chest from '../items/Chest'

const COINS_PER_BLOCK = 3
const COIN_TO_CHEST = 250
const COIN_TO_MINTER = 200
const MINTING_TIME = 1500
const REPEAT_THRESHOLD = 1000
const MINTING_CYCLE = 5000
const BLOCK_TO_CHAIN = 600
const CHAIN_SLIDE = 500

const MAX_MEMPOOL_COINS = 100

export default class Game extends Phaser.Scene
{
	private cursors!: Phaser.Types.Input.Keyboard.CursorKeys
	private playable!: Farmer
	private coins: number = 0
	private NPCs!: object
	private NPC_Objs!: Phaser.Physics.Arcade.StaticGroup
	private coin_queue: Function[] = []
	private newNPC!: Function;
	private removeNPC!: Function;
	private interval: number = 5000
	private lastTick: number = 0

	constructor()
	{
		super('game')
	}

	preload()
    {
		this.cursors = this.input.keyboard.createCursorKeys()
    }

    create()
    {

        const farmer = this.add.sprite(50, 200, 'farmer')
        farmer.anims.play('farmer-idle-down')

		const makeCollider = (p, o) => {
			const c = this.physics.add.collider(p, o, (o1, o2) => {
				o1.halt()
				o2.halt()
				o1.showBubble(true)
				c.active = false;
				this.time.delayedCall(REPEAT_THRESHOLD, () => {
					o1.showBubble(false)
					o1.bump()
					o2.bump()
					this.time.delayedCall(REPEAT_THRESHOLD, () => {
						c.active = true
					}
				})
				var d = chests.getChildren().map((_c) => {
					return { chest: _c, distance: Phaser.Math.Distance.BetweenPoints(o2.body, _c.body) };
				}).sort((i,j) => i.distance - j.distance);
				const moveCoinsAround = (x, y) => {
					for (var c = 0; c < 3; c++) {
						if (d.length > 0) {
							const chest = d.shift().chest

							const coin = this.add.coin(x, y, 'coin')
							this.physics.moveToObject(coin, chest, COIN_TO_CHEST);
							chest.open()
							const collider = this.physics.add.collider(coin, chest, (o1, o2) => {
								this.coin_queue.push(() => chest.add())
								coin.destroy();
								collider.destroy();
								moveCoinsAround(chest.x, chest.y)
							}, undefined, this);
						}
					}
				}
				this.coins++
				sceneEvents.emit('update-tx-count', this.coins)
				moveCoinsAround(o2.body.x, o2.body.y)
			}, undefined, this);
		}

		const animateCoinToMinter = (minter, chest) => {
			const coin = this.add.coin(chest.body.x, chest.body.y, 'coin')
			coin.anims.play('coin-rotate')
			this.physics.moveToObject(coin, minter, COIN_TO_MINTER);
			chest.open()
			const collider = this.physics.add.collider(coin, minter, (o1, o2) => {
				chest.close()
				coin.destroy();
				collider.destroy();
			}, undefined, this);
		}

		this.scene.run('game-ui')

		createCharacterAnims(this.anims)
		createChestAnims(this.anims)

		const map = this.make.tilemap({ key: 'dungeon' })
		const tileset = map.addTilesetImage('rpg_tiles', 'tiles', 16, 16)
		const backLayer = map.createLayer('back', tileset)

		this.playable = this.add.farmer(250, 200, 'farmer')
		const slot = this.add.sprite(this.game.config.width / 2, -16, 'slot')
		var cubes = this.physics.add.staticGroup({ classType: Phaser.GameObjects.Sprite })
		this.physics.world.enableBody(slot, Phaser.Physics.Arcade.STATIC_BODY);

		const chests = this.physics.add.staticGroup({ classType: Chest })
		const minters = this.physics.add.staticGroup({ classType: Minter })

		const pickAMinter = () => {
			const winner = minters.children.entries[Phaser.Math.Between(0,minters.getLength() - 1)]
			this.time.delayedCall(MINTING_CYCLE, () => {
				winner.minted()
				winner.setMempool(this.coins)
				this.time.delayedCall(MINTING_TIME, () => {
					winner.mint()
					const cube = this.add.sprite(winner.x! + 8, winner.y! + 4, 'cube')
					cube.isFirst = cubes.getLength() == 0
					cube.anims.play('cube-rotate')
					this.physics.world.enableBody(cube, Phaser.Physics.Arcade.DYNAMIC_BODY);
					this.physics.moveToObject(cube, slot, undefined, BLOCK_TO_CHAIN)
					const collider = this.physics.add.overlap(cube, slot, (o1, o2) => {
						if (o2.body.y < o1.body.y) {
							const qty = this.coins > COINS_PER_BLOCK ? COINS_PER_BLOCK : this.coins
							winner.setMempool(0)
							chests.getChildren().forEach(i => this.coin_queue.push(() => i.remove(qty)))
							this.coins = Math.max(this.coins - qty, 0)
							sceneEvents.emit('update-tx-count', this.coins)

							cube.stop()
							cube.setFrame(cube.isFirst ? 'cube 11.aseprite' : 'cube 9.aseprite')
							cube.body.setVelocityY(0)
							cube.body.setVelocityX(0)
							cube.body.position.x = slot.body.position.x
							cube.body.position.y = slot.body.position.y
							Phaser.Actions.Call(cubes.getChildren(), i => {
								i.alpha = i.body.position.x > 8 : 1 : 0
								this.add.tween({
									targets: i,
									x: i.body.position.x - 8,
									duration: CHAIN_SLIDE,
									onComplete: () => { i.setFrame(i.isFirst ? 'cube 10.aseprite' : 'cube 8.aseprite') }
								}, this)
							})
							cubes.add(cube)
						}
						collider.destroy()
					})
				})
				pickAMinter()
			})
		}
		const mintersLayer = map.getObjectLayer('minters')
		mintersLayer.objects.forEach(mintObj => {
			minters.get(mintObj.x! + mintObj.width! * 0.5, mintObj.y! - mintObj.height! * 0.5, 'minter')
		})
		pickAMinter()

		const wallsLayer = map.createLayer('walls', tileset)
		wallsLayer.setCollisionByProperty({ collides: 'true' })

		const housesLayer = map.createLayer('houses', tileset)
		housesLayer.setCollisionByProperty({ collides: 'true' })

		const treesLayer = map.createLayer('trees', tileset)
		treesLayer.setCollisionByProperty({ collides: 'true' })

		map.getObjectLayer('chests').objects.forEach(chestObj => {
			chests.get(chestObj.x! + chestObj.width! * 0.5, chestObj.y! - chestObj.height! * 0.5, 'mempool')
		})

		this.physics.add.collider(this.playable, wallsLayer)
		this.physics.add.collider(this.playable, housesLayer)
		this.physics.add.collider(this.playable, treesLayer)
		this.physics.add.collider(this.playable, chests)
		this.physics.add.collider(this.playable, minters)

		var NPCIndex = 0
		const NPCLayer = map.getObjectLayer('people')
		this.NPC_Objs = this.physics.add.staticGroup({ classType: Phaser.GameObjects.Sprite })
		const addNPC = (npcObj) => {
			const char_description = npcObj.properties.find(i => i.name == 'character').value
			const character = this.add[char_description](npcObj.x!, npcObj.y!, char_description)
			this.NPC_Objs.getChildren().forEach(i => {
				makeCollider(character, i)
			})
			this.physics.add.collider(this.playable, character, (o1, o2) => { o2.bump() })
			this.physics.add.collider(character, wallsLayer, (o1, o2) => { o1.bump() })
			this.physics.add.collider(character, housesLayer, (o1, o2) => { o1.bump() })
			this.physics.add.collider(character, treesLayer, (o1, o2) => { o1.bump() })
			this.physics.add.collider(character, chests, (o1, o2) => { o1.bump() })
			this.physics.add.collider(character, minters, (o1, o2) => { o1.bump() })
			character.bump()
			this.NPC_Objs.add(character)
			sceneEvents.emit('new-npc', this.NPC_Objs.getLength())
		}

		NPCLayer.objects.forEach(addNPC)

		this.removeNPC = (npc) => {
			this.NPC_Objs.remove(npc)
			npc.removeAllListeners()
			npc.anims.play('explosion')
			npc.on('animationcomplete', () => {
				npc.removeFromDisplayList()
				npc.removeFromUpdateList()
				npc.destroy()
			})
		}

		this.newNPC = () => {
			const u = NPCLayer.objects[NPCIndex++]
			if (NPCIndex == NPCLayer.objects.length) NPCIndex = 0
			addNPC(u)
		}

		this.input.keyboard.addKey('w').on('up', (e) => {
			this.newNPC()
		})
		this.input.keyboard.addKey('q').on('up', (e) => {
			this.removeNPC(this.NPC_Objs.getChildren()[0])
		})
		this.cameras.main.setBounds(0,-32,700,700)
		this.cameras.main.startFollow(this.playable, true)

		this.input.on(Phaser.Input.Events.POINTER_DOWN, pointer => {
			const v = { x: this.cameras.main.worldView.x + pointer.x, y: this.cameras.main.worldView.y + pointer.y }
			const u = backLayer.worldToTileXY(v.x, v.y)
			const t = backLayer.worldToTileXY(this.playable.x,this.playable.y)
			console.dir(this.cameras.main)

			// 30 - 60 -> .5236 - 1.0472
			// 120 - 150 -> 2.0944 - 2.6180
			const angle = Phaser.Math.Angle.Between(v.x, v.y, this.playable.x, this.playable.y)
			const m = new PlayerMovement(angle > .5236 && angle < 2.6180, angle < -.5236 && angle > -2.6180, angle > -1.0472 && angle < 1.0472, angle > 2.0944 || angle < -2.0944)
			console.log(`angle=${angle} move=${[m.up, m.down, m.left, m.right]}`)
			console.log(`pointer=${v.x} ${v.y} u=${u.x} ${u.y} playable=${this.playable.x} ${this.playable.y} t=${t.x} ${t.y}`)
		})
	}

	private createTestChars() {
		const spriteName = 'merchant';
		this.add.sprite(128, 140, spriteName).anims.play(spriteName + '-idle-down');
		this.add.sprite(160, 140, spriteName).anims.play(spriteName + '-idle-up');
		this.add.sprite(192, 140, spriteName).anims.play(spriteName + '-idle-left');
		this.add.sprite(214, 140, spriteName).anims.play(spriteName + '-idle-right');

		this.add.sprite(128, 170, spriteName).anims.play(spriteName + '-walk-down');
		this.add.sprite(160, 170, spriteName).anims.play(spriteName + '-walk-up');
		this.add.sprite(192, 170, spriteName).anims.play(spriteName + '-walk-left');
		this.add.sprite(214, 170, spriteName).anims.play(spriteName + '-walk-right');
	}

	private handlePlayerChestCollision(obj1: Phaser.GameObjects.GameObject, obj2: Phaser.GameObjects.GameObject)
	{
		const chest = obj2 as Chest
	}

	update(t: number, dt: number)
	{
		if (this.playable) {
			if (this.input.activePointer.isDown) {
				const pointer = this.input.activePointer
				const v = { x: this.cameras.main.worldView.x + pointer.x, y: this.cameras.main.worldView.y + pointer.y }
				if (Phaser.Math.Distance.Between(v.x, v.y, this.playable.getCenter().x, this.playable.getCenter().y) > 16) {
					const angle = Phaser.Math.Angle.Between(v.x, v.y, this.playable.getCenter().x, this.playable.getCenter().y)
					this.playable.update(new PlayerMovement(angle > .5236 && angle < 2.6180, angle < -.5236 && angle > -2.6180, angle > -1.0472 && angle < 1.0472, angle > 2.0944 || angle < -2.0944))
				}
				else
					this.playable.update(new PlayerMovement())
			}
			else
				this.playable.update(this.cursors)
		}
		this.NPC_Objs.getChildren().forEach(i => i.update())
		while (this.coin_queue.length > 0)
			this.coin_queue.pop()()
		if (this.lastTick > 0) {
			if (t - this.lastTick > this.interval) {
				this.newNPC()
 				this.lastTick = t
			}
		}
		else {
			this.lastTick = t
			sceneEvents.emit('new-npc', this.NPC_Objs.getLength())
			sceneEvents.emit('update-tx-count', this.coins)
		}
	}

}
